import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { TOP_PILL } from "../look/topPill";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  LANGUAGE_OPTIONS,
  WIDGET_LANGUAGE_STORAGE_KEY,
  changeLanguageAndPersist,
} from "@/lib/i18n/languageSettings";

/** `buttonClassName`: the button's background — over the salon's header photo the home
 *  screen gives it the same solid backing as its other top buttons. */
export function WidgetLanguageSelector({
  buttonClassName = TOP_PILL,
}: { buttonClassName?: string } = {}) {
  const { t, i18n } = useTranslation();
  const currentLang = (i18n.resolvedLanguage || i18n.language)?.slice(0, 2).toUpperCase() || "EN";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn("flex items-center gap-2 px-3 py-2 rounded-full transition-colors cursor-pointer", buttonClassName)}
          aria-label={t("sidebar.change_language", "Change language")}
          title={t("sidebar.change_language", "Change language")}
        >
          <Globe className="w-5 h-5" />
          <span className="text-sm font-medium">{currentLang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-44 max-h-64 overflow-y-auto">
        {LANGUAGE_OPTIONS.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => {
              void changeLanguageAndPersist(i18n, lang.code, WIDGET_LANGUAGE_STORAGE_KEY);
            }}
            className={i18n.language?.startsWith(lang.code) ? "bg-accent" : ""}
          >
            {lang.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
